import React, { forwardRef } from 'react';
import TextField from '@material-ui/core/TextField';

const CustomTextField = forwardRef(({ rowsMax, maxRows, ...props }, ref) => {
    return <TextField ref={ref} {...props} maxRows={maxRows != null ? maxRows : rowsMax} />;
});

export { CustomTextField as TextField };
